<!-- <div class="enabled-rule-p">  <h6 >{{serviceName}} is not enabled </h6> </div>         -->
<h2 class="enabled-rule-p heading-adfsclient">Service not Available</h2><br>

<p class="show-rule-p">{{serviceName}} is not available due to a scheduled maintenance. We apologize for the inconvenience.</p>
